module.exports = __webpack_public_path__ + "media/images/icons/rarr_white-96e4b0bad7f307013265b26bc24babf2.svg";